import { User } from "../../types/user"
import { generateAPI } from "../api.generator";

export const getWeddingGuestManager = generateAPI<
  {},
  User
>("get", "wedding/guest-manager");
